import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export const FETCH_PRODUCTS_SET_REQUEST = 'FETCH_PRODUCTS_SET_REQUEST';
export const FETCH_PRODUCTS_SET_SUCCEEDED = 'FETCH_PRODUCTS_SET_SUCCEEDED';
export const FETCH_PRODUCTS_SET_FAILED = 'FETCH_PRODUCTS_SET_FAILED';
export type SimpleProductAction = ActionType<typeof actions>;
